import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './data-table.component';
import { DataTableRowComponent } from './data-table-row/data-table-row.component';
import { DataTableCellComponent } from './data-table-cell/data-table-cell.component';
import { DataTableHeaderComponent } from './data-table-header/data-table-header.component';
import { DataTableBodyComponent } from './data-table-body/data-table-body.component';
import { DataTableHeaderCellComponent } from './data-table-header-cell/data-table-header-cell.component';
import { DataTableSearchComponent } from './data-table-search/data-table-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorComponent } from './paginator/paginator.component';
import { PaginationModule } from '@usitsdasdesign/dds-ng/pagination';
import { DataTableFilterComponent } from './data-table-filter/data-table-filter.component';
import { TranslateModule } from '@ngx-translate/core';
import { ResizeHandlerModule } from '@usitsdasdesign/dds-ng/shared/resize-handler';
import { EllipsisTooltipModule } from '../../directives/ellipsis-tooltip/ellipsis-tooltip.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { SelectModule } from '../select/select.module';
import { ButtonModule } from '../button/button.module';
import { NumberedPaginationModule } from '../numbered-pagination/numbered-pagination.module';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [
    DataTableComponent,
    DataTableRowComponent,
    DataTableCellComponent,
    DataTableHeaderComponent,
    DataTableBodyComponent,
    DataTableHeaderCellComponent,
    DataTableSearchComponent,
    PaginatorComponent,
    DataTableFilterComponent,
  ],
  exports: [
    DataTableComponent,
    DataTableRowComponent,
    DataTableCellComponent,
    DataTableHeaderComponent,
    DataTableBodyComponent,
    DataTableHeaderCellComponent,
    DataTableSearchComponent,
    PaginatorComponent,
    DataTableFilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    SelectModule,
    ButtonModule,
    TranslateModule,
    ResizeHandlerModule,
    TooltipModule,
    EllipsisTooltipModule,
    NumberedPaginationModule,
    SearchModule
  ]
})
export class DataTableModule {
}
